var map = {
	"./adjuggernaut/logo_light.png": 67111,
	"./adrev/logo_light.png": 37345,
	"./cartagent/logo_light.png": 12668,
	"./citiesms/logo_light.png": 92689,
	"./hawkemedia/logo_light.png": 53351
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97251;